import isEmpty from 'lodash/isEmpty';

const getCommonData = lang => {
  lang = isEmpty(lang)? 'es': lang;
  return {
    customer_group: '',
    funnel_name: '',
    page_business_line: 'rbwm',
    page_customer_group: '',
    page_language: (lang === 'en')? 'en': `${lang.substring(0, 2)}_MX`,
    page_security_level: '30',
    site_section: 'ib',
  };
};

export default getCommonData;
